export default __webpack_public_path__ + "static/media/Parallax-HUD-Pop-Up (3 Layers).a1aa87f3.jpg";